window.CS_COLOURS = [
  {
    colour: "Light Ivory RAL 1015",
    hex: "#EED9B8",
    range: "standard"
  },
  {
    colour: "Traffic Yellow RAL 1023",
    hex: "#FAD201",
    range: "standard"
  },
  {
    colour: "Pure Orange RAL 2004",
    hex: "#F75E25",
    range: "standard"
  },
  {
    colour: "Traffic Red RAL 3020",
    hex: "#D32221",
    range: "standard"
  },
  {
    colour: "Ultramarine Blue RAL 5002",
    hex: "#2B5DA9",
    range: "standard"
  },
  {
    colour: "Light Blue RAL 5012",
    hex: "#0095C8",
    range: "standard"
  },
  {
    colour: "Night Blue RAL 5022",
    hex: "#2A3756",
    range: "standard"
  },
  {
    colour: "Moss Green RAL 6005",
    hex: "#025430",
    range: "standard"
  },
  {
    colour: "Traffic Green RAL 6024",
    hex: "#009153",
    range: "standard"
  },
  {
    colour: "Anthracite Grey RAL 7016",
    hex: "#2F353B",
    range: "standard"
  },
  {
    colour: "Traffic Grey RAL 7042",
    hex: "#8A8F8F",
    range: "standard"
  },
  {
    colour: "Nut Brown RAL 8011",
    hex: "#5E3C23",
    range: "standard"
  },
  {
    colour: "Signal White RAL 9003",
    hex: "#D7D7D7",
    range: "standard"
  },
  {
    colour: "Jet Black RAL 9005",
    hex: "#0B0B0B",
    range: "standard"
  },
    {
    colour: "Oyster White RAL 1013",
    hex: "#EAE6D5",
    range: "cladding"
  },
  {
    colour: "Light Ivory RAL 1015",
    hex: "#EED9B8",
    range: "cladding"
  },
  {
    colour: "Sulfur Yellow RAL 1016",
    hex: "#F1DD38",
    range: "cladding"
  },
  {
    colour: "Khaki Brown RAL 1019",
    hex: "#D1BFA3",
    range: "cladding"
  },
  {
    colour: "Heathered Moss RAL 1020",
    hex: "#D8C49C",
    range: "cladding"
  },
  {
    colour: "Pure Orange RAL 2004",
    hex: "#F75E25",
    range: "cladding"
  },
  {
    colour: "Purple Red RAL 3004",
    hex: "#701F29",
    range: "cladding"
  },
  {
    colour: "Black Red RAL 3007",
    hex: "#412227",
    range: "cladding"
  },
  {
    colour: "Oxide Red RAL 3009",
    hex: "#6B3F3A",
    range: "cladding"
  },
  {
    colour: "Steel Blue RAL 5011",
    hex: "#1F3438",
    range: "cladding"
  },
  {
    colour: "Fir Green RAL 6009",
    hex: "#27352A",
    range: "cladding"
  },
  {
    colour: "Mountain Sage RAL 6013",
    hex: "#6A726A",
    range: "cladding"
  },
  {
    colour: "Boothbay Blue RAL 7000",
    hex: "#788A8C",
    range: "cladding"
  },
  {
    colour: "Silver Grey RAL 7001",
    hex: "#8A9597",
    range: "cladding"
  },
  {
    colour: "Monterey Taupe RAL 7002",
    hex: "#8C8F85",
    range: "cladding"
  },
  {
    colour: "Signal Grey RAL 7004",
    hex: "#9EA0A1",
    range: "cladding"
  },
  {
    colour: "Timber Bark RAL 7006",
    hex: "#939B92",
    range: "cladding"
  },
  {
    colour: "Evening Blue RAL 7011",
    hex: "#585C5E",
    range: "cladding"
  },
  {
    colour: "Anthracite Grey RAL 7016",
    hex: "#2F353B",
    range: "cladding"
  },
  {
    colour: "Black Grey RAL 7021",
    hex: "#23282B",
    range: "cladding"
  },
  {
    colour: "Umbra Grey RAL 7022",
    hex: "#55595C",
    range: "cladding"
  },
  {
    colour: "Stone Grey RAL 7030",
    hex: "#928E85",
    range: "cladding"
  },
  {
    colour: "Blue Grey RAL 7031",
    hex: "#5B686D",
    range: "cladding"
  },
  {
    colour: "Soft Green RAL 7032",
    hex: "#D6D1C4",
    range: "cladding"
  },
  {
    colour: "Light Grey RAL 7035",
    hex: "#D7D7D7",
    range: "cladding"
  },
  {
    colour: "Dusty Grey RAL 7037",
    hex: "#7A7B7A",
    range: "cladding"
  },
  {
    colour: "Traffic Grey RAL 7042",
    hex: "#8A8F8F",
    range: "cladding"
  },
  {
    colour: "Iron Grey RAL 7043",
    hex: "#5E6362",
    range: "cladding"
  },
  {
    colour: "Cobble Stone RAL 7044",
    hex: "#BDBDB2",
    range: "cladding"
  },
  {
    colour: "Pearl Grey RAL 7047",
    hex: "#C5C6C8",
    range: "cladding"
  },
  {
    colour: "Ochre Brown RAL 8001",
    hex: "#9C6B30",
    range: "cladding"
  },
  {
    colour: "Chestnut Brown RAL 8025",
    hex: "#705A4D",
    range: "cladding"
  },
  {
    colour: "Terra Brown RAL 8028",
    hex: "#4E3B31",
    range: "cladding"
  },
  {
    colour: "Cream RAL 9001",
    hex: "#E9E0D2",
    range: "cladding"
  },
  {
    colour: "Signal White RAL 9003",
    hex: "#D7D7D7",
    range: "cladding"
  },
  {
    colour: "Midnight Black RAL 9004",
    hex: "#0B0B0B",
    range: "cladding"
  },
  {
    colour: "Jet Black RAL 9005",
    hex: "#0B0B0B",
    range: "cladding"
  },
  {
    colour: "White Aluminium RAL 9006",
    hex: "#A5A5A5",
    range: "cladding"
  },
  {
    colour: "Pure White RAL 9010",
    hex: "#F4F4F0",
    range: "cladding"
  },
  {
    colour: "Traffic White RAL 9016",
    hex: "#F6F6F6",
    range: "cladding"
  },

    // CEDRAL colours
  {
    colour: "C01 White",
    hex: "#F1F0E8",
    range: "cladding"
  },
  {
    colour: "C02 Vanilla White",
    hex: "#E6E0CF",
    range: "cladding"
  },
  {
    colour: "C03 Clay Brown",
    hex: "#9C7B69",
    range: "cladding"
  },
  {
    colour: "C05 Platinum Grey",
    hex: "#9A9D9E",
    range: "cladding"
  },
  {
    colour: "C07 Chalk White",
    hex: "#F6F5EF",
    range: "cladding"
  },
  {
    colour: "C10 Sky Blue",
    hex: "#8FB3C5",
    range: "cladding"
  },
  {
    colour: "C15 Steel Grey",
    hex: "#667077",
    range: "cladding"
  },
  {
    colour: "C18 Slate Grey",
    hex: "#474C50",
    range: "cladding"
  },
  {
    colour: "C21 Walnut Brown",
    hex: "#6A5143",
    range: "cladding"
  },
  {
    colour: "C50 Black",
    hex: "#1E1E1E",
    range: "cladding"
  },
  {
    colour: "C51 Silver Grey",
    hex: "#B2B5B4",
    range: "cladding"
  },
  {
    colour: "C52 Pearl",
    hex: "#D8D4C8",
    range: "cladding"
  },
  {
    colour: "C54 Pewter Grey",
    hex: "#777C7C",
    range: "cladding"
  },
  {
    colour: "C71 Sand Yellow",
    hex: "#D6C18A",
    range: "cladding"
  },
  {
    colour: "C72 Brick Red",
    hex: "#9B4435",
    range: "cladding"
  },
  {
    colour: "C73 Ocean Blue",
    hex: "#3E6475",
    range: "cladding"
  },
  {
    colour: "C74 Basalt Grey",
    hex: "#4E5559",
    range: "cladding"
  },
  {
    colour: "C75 Metal Green",
    hex: "#486258",
    range: "cladding"
  },
  {
    colour: "C76 Tea Green",
    hex: "#83957B",
    range: "cladding"
  },
  {
    colour: "C77 Pebble Grey",
    hex: "#A7A49A",
    range: "cladding"
  },
    {
    colour: "C78 Cocoa Brown",
    hex: "#725548",
    range: "cladding"
  },

  // CLADCO colours
  {
    colour: "Black",
    hex: "#000000",
    range: "cladding"
  },
  {
    colour: "Blue",
    hex: "#93BDC4",
    range: "cladding"
  },
  {
    colour: "Cream",
    hex: "#DCD8C7",
    range: "cladding"
  },
  {
    colour: "Granite",
    hex: "#7C7C7C",
    range: "cladding"
  },
  {
    colour: "Light Grey",
    hex: "#BFBFBF",
    range: "cladding"
  },
  {
    colour: "Sage Green",
    hex: "#C4D5A6",
    range: "cladding"
  },
  {
    colour: "Slate",
    hex: "#37353D",
    range: "cladding"
  },
  {
    colour: "White",
    hex: "#F2F2F2",
    range: "cladding"
  }
];

